import moment from 'moment';

import { Patient } from '../resources/types';

export const savePatientRequestInterceptor = (data: any): Partial<Patient> => {
  const { dateOfBirth, phone, email, ...patient } = data;
  let dob = [];
  const contact = [];

  if (/[-]/.test(dateOfBirth) && moment(dateOfBirth, 'MM-DD-YYYY').isValid) {
    dob = dateOfBirth.split('-');
  } else if (/[/]/.test(dateOfBirth) && moment(dateOfBirth, 'MM/DD/YYYY').isValid) {
    dob = dateOfBirth.split('/');
  }

  if (phone) {
    contact.push({
      type: 'sms',
      value: `${phone}`.replace(/[()-\s]/g, ''),
      active: true,
    });
  }
  if (email) {
    contact.push({
      type: 'email',
      value: email,
      active: !phone,
    });
  }
  return {
    ...patient,
    dateOfBirth: {
      year: dob[2],
      month: dob[0],
      day: dob[1],
    },
    contact,
  };
};
